import {
  Autocomplete,
  Checkbox,
  Input,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { type FieldInGroupProps } from "./FormGroup";

export function NormalInput({ field, value, setValue }: FieldInGroupProps) {
  return (
    <Input
      id={field.key}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      type={field.type}
      disableUnderline
      className="form-input"
      name={field.name}
      required={field.required}
    />
  );
}

export function TextAreaInput({ field, value, setValue }: FieldInGroupProps) {
  return (
    <TextField
      id={field.key}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      multiline
      minRows={4}
      fullWidth
      required={field.required}
      name={field.name}
    />
  );
}

export function CheckboxInput({ value, setValue }: FieldInGroupProps) {
  return (
    <Checkbox
      checked={value === "true"}
      onChange={(e) => setValue(e.target.checked.toString())}
    />
  );
}

export function SelectInput({ value, setValue, field }: FieldInGroupProps) {
  const { options = [] } = field;
  return (
    <Select
      MenuProps={{
        sx: {
          maxHeight: "45vh",
        },
      }}
      value={value}
      onChange={(event) => setValue(event.target.value)}
      required={field.required}
      name={field.name}
      defaultValue={options[0].value}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.content}
        </MenuItem>
      ))}
    </Select>
  );
}

export function AutocompleteInput({
  field,
  value,
  setValue,
}: FieldInGroupProps) {
  const { options = [], disabled = false } = field;
  return (
    <Autocomplete
      disabled={disabled}
      slotProps={{
        clearIndicator: {
          sx: {
            padding: "0",
          },
        },
        popper: {
          sx: {
            maxHeight: "45vh",
          },
        },
      }}
      clearIcon={false}
      value={value}
      onChange={(_, newValue) => setValue(newValue ?? "")}
      options={options.map((option) => option.value)}
      getOptionLabel={(value) =>
        options.find((option) => option.value === value)?.content ?? ""
      }
      renderInput={(params) => (
        <TextField
          required={field.required}
          name={field.name}
          {...params}
          disabled={disabled}
          InputProps={{
            ...params.InputProps,
            style: {
              paddingRight: "30px",
            },
          }}
        />
      )}
    />
  );
}
